import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import bookStore from "../../Assets/Projects/BookStore_IS207.png";
import fintech from "../../Assets/Projects/fintech.png";
import dashboard from "../../Assets/Projects/DashBoard.png";
import auction from "../../Assets/Projects/Auction.png";
import blog from "../../Assets/Projects/blog.png";
import chatify from "../../Assets/Projects/chatify.png";
import codeEditor from "../../Assets/Projects/codeEditor.png";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import suicide from "../../Assets/Projects/suicide.png";

const projectList = [
  {
    imgPath: auction,
    title: "AuctionSale Online Auction Platform",
    description:
      "A modern online auction platform where users can list items, join live bidding sessions, and manage auction images. Built as a scalable monorepo with authentication and production-ready deployment setup.",
    ghLink: "https://github.com/AkaDNT/Auction",
    demoLink: "https://vinabid.store/",
  },
  {
    imgPath: fintech,
    title: "Enterprise Fintech Platform",
    description:
      "A fintech platform focused on reliable transaction flows and clean service design. Organized as a monorepo to support faster development and easier scaling.",
    ghLink: "https://github.com/AkaDNT/fintech",
    demoLink: "https://akadnt.shop",
  },
  {
    imgPath: dashboard,
    title: "MobileTech Admin Dashboard",
    description:
      "An admin dashboard for managing a mobile/electronics store. It helps staff track products, orders, customers, and sales performance in one place.",
    ghLink: "https://github.com/AkaDNT/DashBoard",
    demoLink: "https://dash-board-rho-topaz.vercel.app/",
  },
  {
    imgPath: codeEditor,
    title: "Data Warehouse and Decision Analytics",
    description:
      "A data warehouse and decision analytics project (repo: olap). It combines ETL pipelines, OLAP analysis, and BI reports to turn raw data into practical business insights.",
    ghLink: "https://github.com/AkaDNT/olap",
    demoLink:
      "https://drive.google.com/drive/folders/1RxmYsNFNux12kaRFWD0TEMmMvx-aJzPR?usp=drive_link",
  },
  {
    imgPath: chatify,
    title: "Blockchain Marketplace App",
    description:
      "A full-stack blockchain marketplace where users can interact with smart contracts through a web interface. Includes backend services and testing for safer on-chain features.",
    ghLink: "https://github.com/AkaDNT/block-chain",
  },
  {
    imgPath: leaf,
    title: "Project Management Platform",
    description:
      "A project management system for organizing tasks and team workflows. Built with a client-server architecture for clear separation between UI and business logic.",
    ghLink: "https://github.com/AkaDNT/project-management",
  },
  {
    imgPath: emotion,
    title: "LOLCG Real-Time Card Game Platform",
    description:
      "A real-time card game platform with separate web and API apps. Designed to keep game events and player state synchronized smoothly during matches.",
    ghLink: "https://github.com/AkaDNT/LOLCG",
  },
  {
    imgPath: bookStore,
    title: "Online Bookstore Platform",
    description:
      "An online bookstore where users can browse books, place orders, and complete payments. Built as a full-stack system with a modern frontend and robust backend API.",
    ghLink: "https://github.com/AkaDNT/BookStore_IS207",
    demoLink: "https://book-store-is-207.vercel.app/",
  },
  {
    imgPath: dashboard,
    title: "Social Network Analytics and Forecasting",
    description:
      "A social network analytics project that processes data, visualizes trends, and predicts future behavior. Useful for understanding patterns and making data-driven decisions.",
    ghLink: "https://github.com/AkaDNT/Social-Network",
  },
  {
    imgPath: leaf,
    title: "Rental Management Platform",
    description:
      "A rental management platform for handling listings, customer records, and rental operations. Built to keep day-to-day rental workflows simple and organized.",
    ghLink: "https://github.com/AkaDNT/Rental",
  },
  {
    imgPath: blog,
    title: "ABlog Full-Stack Blogging Platform",
    description:
      "A full-stack blogging platform where users can create, manage, and read content. Built with separate frontend and backend services for better maintainability.",
    ghLink: "https://github.com/AkaDNT/ABlog",
  },
  {
    imgPath: fintech,
    title: "EShop E-Commerce Suite",
    description:
      "An e-commerce suite with customer, admin, and API applications. It supports online store operations with a modular structure for future growth.",
    ghLink: "https://github.com/AkaDNT/EShop",
  },
  {
    imgPath: auction,
    title: "Car Bidding Platform",
    description:
      "A car auction platform that enables users to join bidding sessions and track results in real time. Combines a C# backend with a TypeScript frontend.",
    ghLink: "https://github.com/AkaDNT/Car-bidding",
  },
  {
    imgPath: codeEditor,
    title: "IS216 Full-Stack Coursework Project",
    description:
      "A full-stack coursework project with separate backend and frontend parts. Created to practice real-world development flow from coding to deployment.",
    ghLink: "https://github.com/AkaDNT/IS216-JAVA",
  },
  {
    imgPath: chatify,
    title: "Reactivities Event Management System",
    description:
      "An event management application that helps users organize activities and manage event data clearly. Built with clean architecture for easier long-term maintenance.",
    ghLink: "https://github.com/AkaDNT/SMP",
  },
  {
    imgPath: suicide,
    title: "Furniture Landing Page",
    description:
      "A furniture landing page focused on clear product presentation and visual storytelling. Designed to provide a clean and engaging first impression for visitors.",
    ghLink: "https://github.com/AkaDNT/testing",
    demoLink: "https://testing-akadnt.vercel.app",
  },
  {
    imgPath: emotion,
    title: "Travel Service Backend",
    description:
      "A travel service backend built with Node.js and Express. It provides structured APIs for handling travel-related data and core business operations.",
    ghLink: "https://github.com/AkaDNT/traveling",
  },
];

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Featured <strong className="purple">Projects </strong>
        </h1>
        <p style={{ color: "white" }}>
          Danh sách được sắp xếp theo thứ tự repository ghim trước, sau đó đến
          các repository public còn lại.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projectList.map((project) => (
            <Col md={4} className="project-card" key={project.ghLink}>
              <ProjectCard
                imgPath={project.imgPath}
                isBlog={false}
                title={project.title}
                description={project.description}
                ghLink={project.ghLink}
                demoLink={project.demoLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
